import React from 'react';
import { Container, Row, Col } from 'reactstrap';

import image from "../../../assets/kangaroo/AustraliaBanner.jpg"
import "../general.css"
import { useParams } from 'react-router-dom';
import generalService from '../../../services/generalPage';
import { useQuery } from '@tanstack/react-query';
import { imageBaseApi } from '../../../services/imageBaseApi';
import SectionContainer from '../../../Homepage/SectionContainer';
import BreadCrumb from '../../../component/BreadCrumb/BreadCrumb';
import DynamicInlineForm from '../../../component/DynamicInline/DynamicInlineForm';

export default function GeneralPage() {
  const { slug } = useParams();
  console.log("🚀 ~ slug ~ slug:", slug)


  const fetchData = async (slug) => {
    const response = await generalService.getBySlug(slug);
    return response
  }

  const { isPending, error, data: generalData } = useQuery({
    queryKey: ["generalData", slug],
    queryFn: () => fetchData(slug),
  })
  console.log("🚀 ~ GeneralPage ~ generalData:", generalData)

  const renderContent = (htmlContent) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = htmlContent;

    return Array.from(tempDiv.children).map((child, index) => {
      if (child.tagName === "H2") {
        return (
          <Row key={index} className="my-3">
            <Col>
              <h1 className="font-level-7">{child.textContent}</h1>
            </Col>
          </Row>
        );
      }

     if (child.tagName === "P" && child.textContent.trim()) {
  return (
    <Row key={index}>
      <Col>
        <p
          className="country-paragraph-text"
          dangerouslySetInnerHTML={{
            __html: child.innerHTML,
          }}
        />
      </Col>
    </Row>
  );
}

 // Handle unordered lists (UL)
      if (child.tagName === "UL") {
        return (
          <Row key={index}>
            <Col>
              <ul
                className="country-paragraph-text"
                dangerouslySetInnerHTML={{
                  __html: child.innerHTML,
                }}
              />
            </Col>
          </Row>
        );
      }

      // Handle ordered lists (OL)
      if (child.tagName === "OL") {
        return (
          <Row key={index}>
            <Col>
              <ol
                className="country-paragraph-text"
                dangerouslySetInnerHTML={{
                  __html: child.innerHTML,
                }}
              />
            </Col>
          </Row>
        );
      }


      return null;
    });
  };


  return (
    <Container fluid className="p-0">
      <div className='about-hero-banner mb-3' style={{ "--banner-img": `url(${imageBaseApi + generalData?.featuredMedia?.url})` }}>
        <SectionContainer className="d-flex align-items-start pt-5 h-100">
          <BreadCrumb items={[
            { title: "HOME", link: "/" },
            { title: generalData?.title?.toUpperCase() },

          ]} instituition={true} />
          <div className=" page-content text-start h-100 d-flex flex-column justify-content-center">
            <h1 className='font-level-4'>{generalData?.title}</h1>
          </div>
        </SectionContainer>

      </div>



      <SectionContainer>
        <Row className="justify-content-start">
          <Col >
            {/* <div className="text-start mb-4">
              <h1 className="font-level-4 mb-3 lh-1">
                {generalData?.title}
              </h1>
              <p className="lead text-muted">
                {generalData?.subtitle}
              </p>
            </div> */}


            <div className="mt-4">
                {generalData?.content && renderContent(generalData?.content)}


            </div>

          </Col>
        </Row>
      </SectionContainer>

       {(generalData?.slug === "knowledge-and-compliance" ||
  generalData?.slug === "onshore") && (
  <SectionContainer >


    <DynamicInlineForm
      fullName={true}
      email={true}
      phone={true}
      serviceId={true}
      preferedBranchId={true}
      appointment={true}
      isAppointment={true}
      slots={true}
      buttondesc="BOOK YOUR SESSION"
      message={true}
      general={true}
    />
  </SectionContainer>
)}


    </Container>
  );
}